// src/config/brand.js
// Source unique de vérité pour le nom de marque affiché dans l'app.
//
// Reste sur "ARTKIV" tant que le dépôt de marque ARTICHAUT à l'INPI n'est
// pas confirmé. Le jour où c'est bon : changer BRAND_NAME ici suffit à
// mettre à jour le header, le footer et les autres endroits qui l'importent
// — au lieu de chercher/remplacer dans chaque fichier.
//
// Ne couvre pas les textes de contenu (CGV, pages légales, emails, PDF) :
// ceux-là font partie du renommage complet (section B de l'audit), pas de
// cette préparation.

// Piloté par variable d'environnement pour permettre un build de test
// (ex: preview sur app.artichaut.eu) sans changer la valeur par défaut
// utilisée par les builds normaux (artkiv.com).
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "ARTKIV";
export const BRAND_ENDORSEMENT = process.env.REACT_APP_BRAND_ENDORSEMENT || ""; // ex: "par ARTKIV"
export const BRAND_LOGO_VARIANT = process.env.REACT_APP_BRAND_LOGO_VARIANT || "default"; // "default" | "artichaut"
